
import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import ScrollPaginationMixin from "@/mixins/Pagination.mixin";
import { mixins } from "vue-class-component";

@Component
export default class BanksDetailComponent extends mixins(
  ScrollPaginationMixin
) {
  public bankList = [];
  public isBankListEmpty = true;

  public onSearchString() {
    this.paginationConfig.currentPage = 1;
    this.getBankList();
  }

  public onPageChange(page) {
    this.paginationConfig.currentPage = page;
    this.getBankList();
  }
  public goToPath(bankId) {
    this.$router.push({
      path: "/superAdmin/updateBankDetail",
      query: { bankId: bankId },
    });
  }

  public async getBankList() {
    this.asyncPageLoader = true;
    let obj = {
      searchString: this.searchString,
      limit: this.paginationConfig.pageLimit,
      page: this.paginationConfig.currentPage,
      subdomain: this.$client ? this.$client.subdomain : null,
    };
    let response = await Axios.get(API_STORE.ADMIN + "getBankList", {
      params: obj,
      headers: getAPIAuthorizedHeader(),
    });
    this.asyncPageLoader = false;
    if (
      response &&
      response.data &&
      response.data.bankList &&
      response.data.bankList.docs
    ) {
      this.paginationConfig.totalPages = response.data.bankList.pages;
      this.paginationConfig.totalLength = response.data.bankList.total;
      this.bankList = response.data.bankList.docs;
      if (this.bankList.length > 0 && this.counter == 0) {
        this.counter++;
        this.isBankListEmpty = false;
      }
    }
  }

  public confirmDeleteAction(bankId) {
    this.$dialog
      .confirm(`Are you sure you want to delete?`, {
        okText: "Yes",
        cancelText: "No",
        reverse: false,
      })
      .then(() => {
        this.deleteBankDetail(bankId);
      })
      .catch(() => {});
  }

  public async deleteBankDetail(bankId) {
    this.$showLoader(true);
    let response = await Axios.delete(
      API_STORE.ADMIN + "deleteBankDetail/" + bankId,
      { headers: getAPIAuthorizedHeader() }
    );
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.getBankList();
    }
  }

  public confirmAction(checked, bankDetail) {
    this.$dialog
      .confirm(
        `Do you want to ${checked ? "activate" : "disable"} this Bank Detail?`,
        {
          okText: "Yes",
          cancelText: "No",
          reverse: false,
        }
      )
      .then(() => {
        this.updateBankDetail(bankDetail);
      })
      .catch(() => {
        this.getBankList();
      });
  }

  public async updateBankDetail(bankDetail) {
    bankDetail["updateStatus"] = true;
    this.$showLoader(true);
    let response = await Axios.post(
      API_STORE.ADMIN + "updateBankDetail",
      bankDetail,
      { headers: getAPIAuthorizedHeader() }
    );
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.getBankList();
    }
  }

  mounted() {
    this.getBankList();
  }
}
